import { createContext, useContext, useEffect, useState } from "react";
import { setLogoutFunction } from "services/api";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);

  useEffect(() => {
    const savedToken = sessionStorage.getItem("token");
    if (savedToken) {
      setToken(savedToken);
      setIsAuthenticated(true);
    }
    setLogoutFunction(logout);
  }, []);

  const login = (credentials, tokenValue) => {
    setUser(credentials);
    setToken(tokenValue);
    setIsAuthenticated(true);
    sessionStorage.setItem("token", tokenValue); // persist login
  };

  const logout = () => {
    setUser(null);
    setToken(null);
    setIsAuthenticated(false);
    sessionStorage.removeItem("token");
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, user, token, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
